import React from 'react';
import classnames from 'classnames';

import { FormattedMessage } from 'react-intl';

import style from './style.module.less';

const GridHeader = () => (
  <>
    <div className={style['left-header-cell']}>
      <FormattedMessage defaultMessage='Name' description='settings > Client > grid >  Name' id='hxHE3a' />
    </div>
    <div className={classnames(style['text-left'], style['header-cell'])}>
      <FormattedMessage defaultMessage='Email' description='Email header column for the client settings grid' id='y0saTh' />
    </div>
    <div className={style['header-cell']}>
      <FormattedMessage defaultMessage='Status' description='settings > Client > grid > Status' id='4whQGY' />
    </div>
    <div className={style['header-cell']}>
      <FormattedMessage defaultMessage='Carrier Services' description='settings > Client > grid > Carrier Services' id='2Frmlu' />
    </div>
    <div className={style['right-header-cell']}>
      <FormattedMessage defaultMessage='Actions' description='settings > Client > grid > Actions' id='vCieW+' />
    </div>
  </>
);

export default GridHeader;
